/**
 * Contract ABIs for Crystals of Polkadot (FF1 On-Chain JRPG)
 *
 * These ABIs are auto-generated from compiled Solidity contracts.
 * Run `npm run export-abis` from /contracts to regenerate.
 *
 * For backwards compatibility, we export both generated ABIs and
 * manually-defined fallbacks for contracts not yet compiled.
 */

// Import generated ABIs (from compiled contracts)
import {
  CrystalsGameABI,
  PartyABI as GeneratedPartyABI,
  CombatABI as GeneratedCombatABI,
  MagicABI as GeneratedMagicABI,
  WorldABI as GeneratedWorldABI,
  RandomnessABI,
  ClassDataABI,
  ItemDataABI,
  SpellDataABI,
  EnemyDataABI,
} from './generated/abis';

// Re-export generated ABIs with standard names
export const GameABI = CrystalsGameABI;
export const PartyABI = GeneratedPartyABI;
export const CombatABI = GeneratedCombatABI;
export const MagicABI = GeneratedMagicABI;
export const WorldABI = GeneratedWorldABI;

// Export all data contract ABIs
export {
  RandomnessABI,
  ClassDataABI,
  ItemDataABI,
  SpellDataABI,
  EnemyDataABI,
};

// Shop and Inn ABIs (not yet implemented in contracts)
// Using placeholder ABIs until contracts are created
export const ShopABI = [
  'function buyItem(uint8 shopId, uint8 itemId, uint8 quantity) external',
  'function sellItem(uint8 itemId, uint8 quantity) external',
  'function getShopItems(uint8 shopId) external view returns (uint8[] itemIds, uint16[] prices)',
  'function getItemPrice(uint8 shopId, uint8 itemId) external view returns (uint16 price)',
  'event ItemBought(address indexed player, uint8 itemId, uint8 quantity, uint16 totalPrice)',
  'event ItemSold(address indexed player, uint8 itemId, uint8 quantity, uint16 totalPrice)',
] as const;

export const InnABI = [
  'function rest(uint8 innId) external',
  'function getInnPrice(uint8 innId) external view returns (uint16 price)',
  'event Rested(address indexed player, uint8 innId)',
] as const;
